module.exports = __webpack_public_path__ + "static/media/team-swimmy-diego.a44ffe03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/team-swimmy-diego.png
// module id = 2511
// module chunks = 0